//@helpers
const { APIPost } = require('utilities/APIRequestHelper');
const { getURL }  = require('core/apiURLBuilder')
//@constants
const actionTypes = require('constants/actionTypes');
//@actions
const signaturePatternActions = require('actions/signaturePattern');

const setVisibleStep = step => ({
    type: actionTypes.CARD_PIN_CHANGE_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const validateStep = step => ({
    type: actionTypes.CARD_PIN_CHANGE_VALIDATE_STEP,
    payload: {
        step
    }
});

const setNewPin = newPin => ({
    type: actionTypes.CARD_PIN_CHANGE_SET_NEW_PIN,
    payload: {
        newPin
    }
});

const setNewPinConfirmation = newPinConfirmation => ({
    type: actionTypes.CARD_PIN_CHANGE_SET_NEW_PIN_CONFIRMATION,
    payload: {
        newPinConfirmation
    }
});

const requestPinChangeSuccess = () => ({
    type: actionTypes.CARD_PIN_CHANGE_SUCCESFUL
});

const requestPinChangeRequest = () => ({
    type: actionTypes.CARD_PIN_CHANGE_REQUEST
});

const requestPinChangeFailure = error => ({
    type: actionTypes.CARD_PIN_CHANGE_FAILURE,
    payload: {
        error
    }
});

const resetView = () => ({
    type: actionTypes.CARD_PIN_CHANGE_RESET_VIEW
})

const requestPinChange = cardId => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);
    const newPin = getState().cardPinChange.get('newPin');

    const callback = (dispatch, getState, dataToken) => {
        const params = {
            query: {
                contrato: {
                    numerodecontrato: immCard.getIn(['contract', 'number']),
                    producto: immCard.getIn(['contract', 'product']),
                },
                dataToken,
                numeroTarjeta: immCard.get('number'),
                pin: parseInt(newPin)
            }
        };

        dispatch(requestPinChangeRequest());
        APIPost(dispatch, getURL('cardPinChange'), params)
        .then( response => {
            dispatch(requestPinChangeSuccess(response));
        })
        .catch( response => {
            dispatch(requestPinChangeFailure(response.error));
        });
    }

    if (immCard && newPin) {
        return Promise.resolve().then(function() {
            signaturePatternActions.validateAndExecute(dispatch, getState, callback);
        });
    }
};

module.exports = {
    requestPinChange,
    setNewPin,
    setNewPinConfirmation,
    setVisibleStep,
    validateStep,
    resetView
};
